import {SET_BANKS_ACCOUNTS} from '../mutation-types';
import {getBankAccounts} from '../../api/bank-api';

const initialState = {
    accounts: []
};

const mutations = {
    [SET_BANKS_ACCOUNTS](state, bankAccounts) {
        state.accounts = bankAccounts;
    }
};

const actions = {
    loadBanksAccounts({commit}) {
        getBankAccounts().then(bankAccounts => {
            commit(SET_BANKS_ACCOUNTS, bankAccounts)
        });
    }
};

export default {
    state: initialState,
    mutations,
    actions
}